import React from "react";
import { NavLink } from "react-router-dom";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import "./Footer.css";
import logo from "../assets/logo.png";

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-content">
        <div className="footer-top">
          
          {/* LEFT - LOGO */}
          <div className="footer-logo">
            <img src={logo} alt="SIP Abacus Logo" />
          </div>

          {/* CENTER - TITLE */}
          <div className="footer-brand">
            <h3>SIP Abacus</h3>
            <p>
              Building strong brains <br />
              with the power of Abacus learning.
            </p>
          </div>

          {/* RIGHT - LINKS */}
          <div className="footer-links-wrap">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><NavLink to="/">Home</NavLink></li>
              <li><NavLink to="/about">About</NavLink></li>
              <li><NavLink to="/courses">Courses</NavLink></li>
              <li><NavLink to="/why-abacus">Why Abacus</NavLink></li>
              <li><NavLink to="/gallery">Gallery</NavLink></li>
              <li><NavLink to="/contact">Contact</NavLink></li>
            </ul>
          </div>

        </div>

        {/* SOCIAL */}
        <div className="footer-social">
          <a
                href="https://www.instagram.com/sipabacusmalkajgiri/?hl=en"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
            <FaInstagram />
          </a>
          <a
                href="https://www.facebook.com/vanaja.gorantala"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
            <FaFacebookF />
          </a>
        </div>

        {/* BOTTOM */}
        <div className="footer-bottom">
          <span>© 2026 SIP Abacus. All rights reserved.</span>

          <a
            href="https://vrnd.tech"
            target="_blank"
            rel="noreferrer"
            className="powered-by"
          >
            Powered by VRND Business Solutions
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;